
const BeneficiosComunidade = () => {
  const beneficios = [
    {
      icon: 'ri-seedling-fill',
      titulo: 'Plante Transformação',
      descricao: 'Cada convite é uma semente de autoconhecimento que você planta na vida de alguém especial.',
    },
    {
      icon: 'ri-team-fill',
      titulo: 'Cresça em Comunidade',
      descricao: 'Compartilhe experiências, inspire-se com histórias reais e cresça junto com pessoas que acreditam no futuro.',
    },
    {
      icon: 'ri-gift-fill',
      titulo: 'Presente Significativo',
      descricao: 'Convide alguém para escrever uma carta — é o presente mais profundo e pessoal que você pode dar.',
    },
    {
      icon: 'ri-sparkling-fill',
      titulo: 'Impacto Multiplicado',
      descricao: 'Quando você inspira alguém, essa pessoa inspira outra. O efeito cascata da transformação é infinito.',
    },
  ];

  return (
    <section className="bg-luxury-ivory py-28 relative">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent"></div>

      <div className="container mx-auto px-6 lg:px-16">
        <div className="flex items-center justify-center gap-4 mb-4">
          <div className="w-12 h-px bg-gold-500/40"></div>
          <span className="font-['Montserrat'] text-xs tracking-[0.3em] uppercase text-gold-600">
            Por que compartilhar
          </span>
          <div className="w-12 h-px bg-gold-500/40"></div>
        </div>

        <h2 className="font-['Playfair_Display'] text-4xl lg:text-5xl text-center text-luxury-charcoal mb-4">
          O poder de convidar
        </h2>
        <p className="font-['Montserrat'] text-sm text-luxury-charcoal/40 text-center max-w-lg mx-auto mb-16 font-light tracking-wide">
          Descubra como um simples convite pode transformar vidas
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {beneficios.map((item, index) => (
            <div
              key={index}
              className="bg-cream-50 rounded-2xl p-8 border border-gold-500/10 hover:border-gold-500/25 hover:shadow-gold transition-all duration-500 group text-center"
            >
              <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-gold-500/10 to-gold-600/10 flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-500">
                <i className={`${item.icon} text-gold-600 text-2xl`}></i>
              </div>

              <h3 className="font-['Playfair_Display'] text-lg font-semibold text-luxury-charcoal mb-3">
                {item.titulo}
              </h3>

              <p className="font-['Montserrat'] text-xs text-luxury-charcoal/40 leading-relaxed font-light">
                {item.descricao}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BeneficiosComunidade;
